<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-envelope fa-fw" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">R{{ plan.id }}</div>
            <div class="meta mt-1" v-if="plan.users">
                <i class="fas fa-user mr-2 fa-fw"></i>{{ plan.users.first_name }} {{ plan.users.last_name }}
            </div>
            <div class="meta mt-1" v-if="plan.users">
                <div><i class="fas fa-address-card mr-2 fa-fw"></i>{{ plan.users.address }}<span v-if="plan.users.address_2">, {{ plan.users.address_2 }}</span></div>
                <div><i class="fas mr-2 fa-fw"></i>{{ plan.users.city }}, {{ plan.users.state }} &nbsp;{{ plan.users.zip }}</div>
            </div>

            <b-tag :type="statusType" class="mt-1"><i class="fas fa-flag fa-fw mr-2"></i>{{ status }}</b-tag>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";
    import numeral from "numeral";

    export default {
        name: 'PendingLetter',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            plan: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {}
        },
        computed: {
            //let statuses = ['ready', 'printing', 'processed_for_delivery', 'completed'];

            status: function () {
                if (this.plan.postgrid_mail_status === 0) {
                    return 'Not Initiated';
                } else if (this.plan.postgrid_mail_status === 1) {
                    return 'Submitted for Printing';
                } else if (this.plan.postgrid_mail_status === 2) {
                    return 'Printing';
                } else if (this.plan.postgrid_mail_status === 3) {
                    return 'Processed for Delivery';
                } else if (this.plan.postgrid_mail_status === 4) {
                    return 'Completed';
                } else if (this.plan.postgrid_mail_status === 5) {
                    return 'Ignored';
                } else if (this.plan.postgrid_mail_status === 6) {
                    return 'PostGrid Error';
                } else {
                    return 'Unknown';
                }
            },
            statusType: function () {
                if (this.plan.postgrid_mail_status === 0) {
                    return 'is-warning is-light';
                } else if (this.plan.postgrid_mail_status === 1) {
                    return 'is-primary is-light';
                } else if (this.plan.postgrid_mail_status === 2) {
                    return 'is-link is-light';
                } else if (this.plan.postgrid_mail_status === 3) {
                    return 'is-info is-light';
                } else if (this.plan.postgrid_mail_status === 4) {
                    return 'is-success is-light';
                } else if (this.plan.postgrid_mail_status === 5) {
                    return 'Ignored';
                } else if (this.plan.postgrid_mail_status === 6) {
                    return 'is-danger is-light';
                } else {
                    return 'is-danger is-light';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tile-title {
        font-size: 0.9rem;
        font-weight: bold;
    }
</style>
